import React, { useEffect, useState } from 'react';
import './ProcessingAnimation.css';

interface ProcessingAnimationProps {
  title: string;
  description: string;
  steps?: string[];
  currentStep?: number;
}

export const ProcessingAnimation: React.FC<ProcessingAnimationProps> = ({
  title,
  description,
  steps,
  currentStep = 0
}) => {
  const [animatedStep, setAnimatedStep] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);
  
  // デバッグ用ログ
  console.log('ProcessingAnimation rendered:', { title, description, steps, currentStep });

  useEffect(() => {
    // ステップを自動的に進める（実際のAPIレスポンスがない場合のデモ用）
    if (steps && steps.length > 0 && currentStep === 1) {
      const interval = setInterval(() => {
        setAnimatedStep(prev => {
          if (prev >= steps.length - 1) {
            clearInterval(interval);
            return prev;
          }
          return prev + 1;
        });
      }, 2000);
      return () => clearInterval(interval);
    } else if (currentStep > 1) {
      setAnimatedStep(currentStep);
    }
  }, [steps, currentStep]);

  useEffect(() => {
    // プログレスバーのアニメーション
    if (steps && steps.length > 0) {
      const percentage = ((animatedStep + 1) / steps.length) * 100;
      setProgressPercentage(percentage);
    }
  }, [animatedStep, steps]);
  return (
    <div className="processing-animation">
      <div className="processing-animation__content">
        {/* アニメーションアイコン */}
        <div className="processing-animation__icon-wrapper">
          <div className="processing-animation__icon">
            <div className="processing-animation__circle processing-animation__circle--1"></div>
            <div className="processing-animation__circle processing-animation__circle--2"></div>
            <div className="processing-animation__circle processing-animation__circle--3"></div>
          </div>
        </div>
        
        {/* タイトルと説明 */}
        <h3 className="processing-animation__title">{title}</h3>
        <p className="processing-animation__description">{description}</p>
        
        {/* ステップインジケーター（オプション） */}
        {steps && steps.length > 0 && (
          <div className="processing-animation__steps">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className={`processing-animation__step ${
                  index < animatedStep ? 'completed' : 
                  index === animatedStep ? 'active' : ''
                }`}
              >
                <div className="processing-animation__step-icon">
                  {index < animatedStep ? '✓' : index + 1}
                </div>
                <span className="processing-animation__step-text">{step}</span>
              </div>
            ))}
          </div>
        )}
        
        {/* プログレスバー */}
        <div className="processing-animation__progress">
          <div className="processing-animation__progress-bar">
            <div 
              className="processing-animation__progress-fill"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
          <div className="processing-animation__progress-text">
            {Math.round(progressPercentage)}%
          </div>
        </div>
      </div>
    </div>
  );
};